export default "__VITE_ASSET__d6372015__"